// features/cen/cenSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { removeUserToken } from './slice';

const cenSlice = createSlice({
  name: 'cen',
  initialState: {
    selectedCEN: null, // Initial state
  },
  reducers: {
    setSelectedCENId: (state, action) => {
      state.selectedCEN = action.payload; // Update the selected CEN ID
    },
    resetSelectedCEN: (state) => {
        state.selectedCEN = null; // Reset to null
      },
     
  },
  extraReducers: (builder) => {
    builder.addCase(removeUserToken, (state) => {
      state.selectedCEN = null; // Reset to null on logout
    });
}
});

export const { setSelectedCENId, resetSelectedCEN } = cenSlice.actions;

export default cenSlice.reducer;
